import type { RouteRecordRaw } from "vue-router";

const managerRoutes: RouteRecordRaw[] = [
  {
    path: "/manager/salesOverview",
    name: "view-sales-overview",
    component: () => import("@/views/Manager/ViewSalesOverview.vue"),
    meta: {
      title: "Sales Overview",
      requiresAuth: true,
      managerRequired: true,
    },
  },
];

export default managerRoutes;
